import { debugApi } from "../api/index";
import ycpSignature from "@/utils/ycp-signature";

// 埋点统计 
const actionEvent = async (dataType) => {
  const deviceId = ycpSignature.generateDeviceId();
  console.log( Date.now())
  const data = {
    deviceId: deviceId,
    userId: null,
    actionTime : Date.now(),
    actionType: dataType,
    fromSource: 'h5',
    refer: document.referrer || window.location.hostname,
    pagePath: window.location.href,
    dataType: 0,
    dataId: 0,
  };
  console.log(data)
  try {
    const response = await debugApi.trackEvent(data);
    console.log('埋点统计成功:', response);
  } catch (error) {
    console.error('埋点统计失败:', error);
  }
}

export default actionEvent
